<template>
  <section class="bg-gray">
    <div class="container">
      <breadcrumb v-if="!isMobile" crumb="shipping-add" />
      <el-row
        :gutter="isMobile ? 0 : 24"
        :class="isMobile ? 'ship-mobile' : ''"
      >
        <el-col :lg="edit ? 24 : 18">
          <div class="my_container-card">
            <el-alert
              v-if="isExp && !client && !loadClient"
              title="Вы пока не можете создать перевозку, обратитесь к администрации, тел: 8 (800) 250-75-31"
              type="warning"
              show-icon
            />
            <el-card v-else class="box-card">
              <div class="my_container-card-steps">
                <el-steps
                  :active="active_step"
                  align-center
                  finish-status="success"
                >
                  <el-step title="Погрузка" />
                  <el-step title="Выгрузка" />
                  <el-step v-if="userCustomFields" title="Доп. информация" />
                  <el-step title="Груз и оплата" />
                </el-steps>
              </div>
              <section class="my_container">
                <loader-wrapper
                  :loading="loading"
                  background="rgba(249,249,249,.9)"
                >
                  <component
                    :is="currentStep[active_step]"
                    :saved="formData"
                    :edit="edit"
                    :fields="userCustomFields"
                    @change_step="changeStep"
                    @req_shipping="reqShipping"
                    @invalid="invalid"
                  />
                </loader-wrapper>
              </section>
            </el-card>
          </div>
        </el-col>
        <el-col v-if="!edit && !isMobile" :span="6">
          <hint />
        </el-col>
      </el-row>
    </div>
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import CustomFields from './Steps/CustomFields'
import Hint from '@/components/Hints/Hint'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import OneStep from './Steps/One'
import ThreeStep from './Steps/Three'
import TwoStep from './Steps/Two'

const Bids = RepositoryFactory.get('bids')

export default {
  name: 'ShippingAdd',
  components: {
    CustomFields,
    OneStep,
    TwoStep,
    ThreeStep,
    Hint,
    Breadcrumb,
    LoaderWrapper,
  },
  props: {
    bids: {
      type: Object,
      default: () => undefined,
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
    step: {
      type: Boolean,
      default: () => false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      active_step: 0,
      currentStep: ['one-step', 'two-step', 'custom-fields', 'three-step'],
      formData: {
        org_performer_id: 13815,
        load_point: '',
        load_point_kladr_id: '',
        load_coords_lat: '',
        load_coords_lon: '',
        load_start_date: '',
        load_type_id: '',
        lifting_capacity: undefined,
        cars_count: undefined,
        is_trawl: '',
        client: null,
        distance_libra: undefined,
        type_code: 'delivery',
        unload_point: '',
        unload_point_kladr_id: '',
        unload_coords_lat: '',
        unload_coords_lon: '',
        cargo_receiver_address: '',
        cargo_receiver_legal_name: '',
        cargo_receiver_name: '',
        distance: undefined,
        freight_id: '',
        weight: undefined,
        allow_shortage: undefined,
        allow_shortage_is_percents: 1,
        price_from_storage_bidder: undefined,
        price_from_storage_driver: undefined,
        price_from_field_bidder: undefined,
        price_from_field_driver: undefined,
        freight_price_per_kg: undefined,
        comment: '',
        private_comment: '',
        extra_fields: {},
        managers: undefined,
        carrier_request_number: '',
        is_tudatka: 0,
        require_payment: 0,
      },
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      getByKey: 'userProfile/getByKey',
      getClients: 'clients/getList',
      loadClient: 'clients/getLoading',
    }),
    client() {
      return this.getClients(this.curOrgId)
    },
    user_org() {
      return this.getByKey('current', 'organization')
    },
    userCustomFields() {
      const { custom_fields } = this.user_org
      const extra_fields = {}

      if (!custom_fields) {
        return null
      }
      const types = custom_fields.filter(f => {
        if (f.category !== 'bids') {
          return false
        }
        const field = this.formData.extra_fields
          ? this.formData.extra_fields[f.id]
          : null

        extra_fields[f.id] =
          field && field.value ? field.value : f.default_value

        return true
      })

      return custom_fields.length ? { types, extra_fields } : null
    },
    isExp() {
      return this.userInfo.user_type === 2
    },
  },
  watch: {
    bids: {
      immediate: true,
      handler(newBid) {
        this.checkData(newBid)
      },
    },
    step(newVal) {
      this.active_step = newVal ? 3 : 0
    },
  },
  methods: {
    ...mapActions({
      fetchItem: 'clients/fetchItem',
      fetchManagers: 'managers/fetchManagers',
    }),
    ...mapMutations('bids', ['updateBidData']),
    checkData(newBid) {
      this.active_step = this.step ? 3 : 0

      if (this.edit) {
        for (let key in this.formData) {
          if (!Object.prototype.hasOwnProperty.call(this.formData, key)) {
            continue
          }
          this.formData[key] = newBid[key]
        }

        if (this.isAdminOrCeoRole) {
          this.formData.client = {
            id: newBid.org_client_id,
            short_name: newBid.client_short_name,
          }
        }
        this.formData = { ...this.formData }
      } else {
        if (this.isExp) {
          this.fetchItem(this.curOrgId)
        }
        this.fetchManagers()
        const bid = JSON.parse(localStorage.getItem('saved-bid'))

        if (bid) {
          this.formData = { ...this.formData, ...bid }
        }
      }
    },
    invalid() {
      if (this.isMobile) {
        this.$message.error('Исправьте ошибки валидации')
      }
    },
    changeStep({ data, step }) {
      if (this.active_step === 1 && step > 0 && !this.userCustomFields) {
        step++
      } else if (this.active_step === 3 && step < 0 && !this.userCustomFields) {
        step--
      }
      this.active_step += step
      this.formData = { ...this.formData, ...data }
    },
    toArr(item) {
      if (typeof item === 'number') {
        return [item]
      }

      return item === null ? [] : item
    },
    reqShipping(fields) {
      this.loading = true
      this.formData.managers_ids = this.toArr(fields.managers)
      this.formData = { ...this.formData, ...fields }

      if (this.isAdminOrCeoRole && this.formData.client) {
        this.formData.org_client_id = this.formData.client.id
      }
      delete fields.managers
      delete this.formData.client

      if (!this.edit) {
        this.formData.user_org_inn = this.cur_org_inn
        Bids.postBids(this.formData)
          .then(() => this.afterSave())
          .catch(err => this.errHandler(err))
          .finally(() => (this.loading = false))
      } else {
        Bids.patchBids(this.bids.id, this.formData)
          .then(({ data }) => {
            this.onClose('dialog_edit_shipping')
            this.$message.success('Заявка обновлена успешно')
            this.updateBidData({ id: data.id, data })
          })
          .catch(err => this.errHandler(err))
          .finally(() => (this.loading = false))
      }
    },
    afterSave() {
      localStorage.setItem('saved-bid', JSON.stringify(this.toSave()))
      this.$confirm('', 'Заявка сохранена успешно', {
        confirmButtonText: 'Добавить еще одну',
        cancelButtonText: 'Перейти к списку заявок',
        type: 'success',
        center: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
      })
        .then(() => this.updatePage())
        .catch(() => this.$router.push({ path: '/home' }))
    },
    toSave() {
      const {
        lifting_capacity,
        distance_libra,
        cars_count,
        distance,
        weight,
        allow_shortage,
        allow_shortage_is_percents,
        freight_price_per_kg,
        comment,
        private_comment,
      } = this.formData

      return {
        lifting_capacity,
        distance_libra,
        cars_count,
        distance,
        weight,
        allow_shortage,
        allow_shortage_is_percents,
        freight_price_per_kg,
        comment,
        private_comment,
      }
    },
    updatePage() {
      const bid = JSON.parse(localStorage.getItem('saved-bid'))

      if (bid) {
        this.formData = { ...this.formData, ...bid }
      }
      this.active_step = 0
    },
  },
}
</script>

<style lang="sass">
.step_autocomplite
  width: 100%

.my_container-back
  margin-bottom: 20px

.my_container-card
  .my_container-card-title
    font-family: Tahoma, serif
    font-size: 22px
    line-height: 17px
  .my_container-card-action
    padding: 0 20px
    display: flex
    justify-content: space-between
  .my_container-card-steps
    background-color: #F2F4F6
    padding: 20px 0 10px 0
    .el-step__title
      line-height: 20px
  .manager-loader
    min-height: 100px
  .my_container
    background-color: #F8FAFB
    .el-form-item__content
      line-height: normal
      font-size: unset
    .bottom_buttons
      margin: 30px 0 0 0
      display: flex
      justify-content: space-between
    .el-input-number
      width: 100%
    .c-quick-pick__link
      margin-right: 15px

.fast_select
  padding: 0
  font-size: 13px
  line-height: 19px
  span
    color: #B5B5B5
  li
    list-style-type: none

.line_list
  display: flex
  li
    margin: 0 10px
.st_price
  background: #eee
  border: 1px dashed #aaa
.cargo-block
  border: 1px dashed #DCDFE6
  padding-bottom: 10px
  .el-select
    margin-bottom: 10px
  .el-form-item
    margin-bottom: 10px
.ship-mobile
  margin: -12px
  padding-top: 10px
  padding-bottom: 50px
  .el-card__body
    padding: 0
.steps-content
  .el-divider
    margin-bottom: 5px
  .el-divider__text
    background: #F9F9F9
    font-weight: normal
    color: #B5B5B5
  .add-new-client
    margin-left: 15px
  .small-radio .el-radio-button__inner
    font-size: 12px
    padding: 7px 19px
</style>
